import { endOfWeek, startOfWeek } from 'date-fns';

/** The current Monday–Sunday week as the stats endpoint's ISO range. */
export const thisWeek = () => {
  const now = new Date();
  return {
    from: startOfWeek(now, { weekStartsOn: 1 }).toISOString(),
    to: endOfWeek(now, { weekStartsOn: 1 }).toISOString(),
  };
};
